import { Button, Center, Heading, Image, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import React, { ReactNode } from "react";

interface bluePrintProps {
  description?: string;
  title?: string;
  goTo?: string;
  goToTitle?: string;
  illustration?: ReactNode;
  mtop?: number;
}

interface networkProps {
  description?: string;
}

const BluePrint = ({ description, mtop = 1, title, goTo, goToTitle, illustration }: bluePrintProps) => {
  const router = useRouter();
  return (
    <Center flexDir="column" textAlign="center">
      {/* <Image src="/Errors/404.svg" /> */}
      {illustration}

      {title && (
        <Heading as="h1" color="blue.500" fontSize="3xl" mt={6} fontWeight={900}>
          {title}
        </Heading>
      )}

      {description && <Text mt={mtop}>{description}</Text>}

      {goTo && (
        <Button mt={6} fontSize="sm" size="lg" px={6} onClick={() => router.back()} fontWeight={700} colorScheme="blue" borderRadius="lg">
          {goToTitle}
        </Button>
      )}
    </Center>
  );
};

const NetworkError = ({ description }: networkProps) => {
  return (
    <BluePrint
      illustration={<Image src="/Errors/network-error.svg" w="300px" />}
      description={description || "No Network Available"}
      mtop={8}
    />
  );
};

export { NetworkError };
